import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const Campaigns = {
  CampaignsList: lazyNamed(() => import('./containers/CampaignsList/index.tsx'), 'CampaignsList'),
  CampaignOverview: lazyNamed(() => import('./containers/CampaignOverview/index.tsx'), 'CampaignOverview'),
  CampaignHistory: lazyNamed(() => import('./containers/CampaignHistory/index.tsx'), 'CampaignHistory'),
  CampaignCreateForm: lazyNamed(() => import('./containers/CampaignCreateForm/index.tsx'), 'CampaignCreateForm'),
  PositionCreateForm: lazyNamed(() => import('./containers/PositionCreateForm/index.tsx'), 'PositionCreateForm'),
  PositionEditForm: lazyNamed(() => import('./containers/PositionEditForm/index.tsx'), 'PositionEditForm'),
  PositionHistory: lazyNamed(() => import('./containers/PositionHistory/index.tsx'), 'PositionHistory'),
  CampaignSummary: lazyNamed(() => import('./containers/CampaignSummary/index.tsx'), 'CampaignSummary'),
  OrderPreview: lazyNamed(() => import('./containers/OrderPreview/index.tsx'), 'OrderPreview'),
};
